import DashboardService from "../../../../../services/Dashboard";

export function searchStocks(searchText){
    return DashboardService.searchTickers(searchText).then(results=>{
        return Object.keys(results).map(nasdaq=>{
            return {
                nasdaq,
                name:results[nasdaq]
            }
        })
    });
}

export function getStockDetails(stock){
    return new Promise ((resolve)=>{
        resolve({
            ticker:stock
        })
    })
}